// Init sortable

function initSortable(selector) {
  var model = $(selector).attr('data-model');

  var sortableInstance = sortable(selector, {
    handle: '.list-item__icon--drag-handle',
    placeholderClass: 'list-item__row list-item__row--placeholder',
    forcePlaceholderSize: true,
    dropTargetContainerClass: 'is-drop-target'
  })[0];

  sortableInstance.addEventListener('sortupdate', function (ev) {
    var id = $(ev.detail.item).attr('data-id');
    var table = $(ev.detail.item).attr('data-table');
    var nextItem = $(ev.detail.item).next();
    var afterId = nextItem.length ? nextItem.attr('data-id') : -1;
    var afterTable = nextItem.length ? nextItem.attr('data-table') : -1;
    var defaultOrderKey = $('.list-items__wrapper').attr('data-default-order-key') || 'order';
    var defaultOrder = $('.list-items__wrapper').attr('data-default-order') || 'asc';
    saveOrder(model, table, afterTable, id, afterId, defaultOrderKey, defaultOrder);
  });

  sortableInstance.addEventListener('sortstart', function (e) {
    $('body').addClass('is-dragging');
  });

  sortableInstance.addEventListener('sortstop', function (e) {
    $('body').removeClass('is-dragging');
  });
}

// Initialize sortables when DOM is ready

$(function () {
  var sortableSelector = '.list-items__container[data-sortable="1"]';
  if ($(sortableSelector).length) {
    initSortable(sortableSelector);
  }
});

// Request to save new order

function saveOrder(model, table, afterTable, id, afterId, key, direction) {
  if (app.savingOrder) {
    return;
  }

  $.ajax({
    url: '/admin/request/order',
    method: 'post',
    data: {
      model: model,
      table: table,
      after_table: afterTable,
      id: id,
      after_id: afterId,
      key: key || 'order',
      direction: direction || 'asc'
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.savingOrder = true;
    },
    success: function (response) {
      app.savingOrder = false;

      if (response && response.success) {
        success('Reihenfolge gespeichert');
        return;
      }

      error();
    },
    error: function () {
      app.savingOrder = false;
      ajaxError();
    }
  });
}
